module.exports = __webpack_public_path__ + "static/media/24-iveco.a7fdae3d.jpg";